import React, { useEffect, useState, Suspense, lazy } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Header from "./components/Header";
import Layout from "./components/Layout";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

// ✅ Lazy load all page components
const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));
const Contact = lazy(() => import("./pages/Contact"));

function App() {
  const navigate = useNavigate();
  const [hasRefreshed, setHasRefreshed] = useState(false);

  useEffect(() => {
    const isPageRefresh = window.performance.getEntriesByType("navigation")[0]?.type === "reload";
    if (isPageRefresh && !hasRefreshed) {
      setHasRefreshed(true);
      navigate("/");
    }
  }, [navigate, hasRefreshed]);

  return (
    <>
      <Header />
      {/* ✅ Wrap routes with Suspense */}
      <Suspense fallback={<div className="text-center my-5">Loading...</div>}>
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/services" element={<Layout><Services /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="*" element={<Layout><Home /></Layout>} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
